import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router-dom';
import UserStore, {UserStoreTypes} from '@/stores/user';
import {Device, Resident, Toolbar, Group, Modal, PhoneModal, FileOpear} from '@/components';
import Active from '@/components/Modal/Active'
import {EventType} from '@/components/Toolbar'
import {useEffectOnce, useLocalStorage, useMount} from 'react-use';
import BaseStore, {BaseStoreTypes} from '@/stores/base';
import DeviceStore, {DeviceStoreTypes} from '@/stores/device';
import UIStore, {UIStoreTypes} from '@/stores/ui'
import {Row, Col, Modal as AModal, message,} from 'antd';
import useReactRouter from 'use-react-router';
import * as R from 'ramda';
import Encryption from '@/utils/Encryption';
import log from '@/utils/log'
import {getActive as getActiveApi} from '@/services/Active'
import CloseDown from "@/components/Modal/closeDown";

export interface PropsType {
  UserStore: UserStoreTypes;
  BaseStore: BaseStoreTypes;
  DeviceStore: DeviceStoreTypes;
  UIStore: UIStoreTypes
}

type SignInProps = PropsType & RouteComponentProps;

const Home: React.FC<SignInProps> = inject('UserStore', 'BaseStore', 'DeviceStore', 'UIStore')(observer(props => {
  const {history} = useReactRouter();

  const {GroupStore} = props.UserStore;
  const [roomData]: any = useLocalStorage('activeRoom');
  const {DeviceBaseStore, DeviceOperation, DeviceModalStore} = props.DeviceStore;
  const {groupAppInstallList, groupAppUninstall, setInUnList, appInstallUninstall} = DeviceOperation.AppManagementStore;
  // 活动信息
  const {getShowActive, onChangeShowActive, isUsedFreeDevice, alreadyShowActive} = props.UIStore.ActiveStore
  // 公告信息
  const {getnNoticeInfo} = props.UIStore.CloseDown

  const {RenewalStore} = props.UserStore

  const [plainOptions, setPlainOptions] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [activeKey, setActiveKey] = useState('-1');

  const [userInfo]: any = useLocalStorage('userInfo');
  const {token} = userInfo;
  const decodeInfo = JSON.parse(Encryption.decayFun(token, 'NgAbCJJGfUlQ6653'));


  /* 运行停止 */
  const [runOrStopVisible, setRunOrStopVisible] = useState(false);
  const [runOrStop, setrunOrStop] = useState(true);

  /* ip代理弹窗状态 */
  const [vasIpProxyVisible, setVasIpProxyVisible] = useState(false);

  /* 新建分组 0 修改分组名称 1 修改设备名称输入弹窗 2 */
  const [inputNameVisible, setInputNameVisible] = useState(false);
  const [inputNameState, setInputNameState] = useState(0);
  const [inputName, setInputName] = useState('');
  const [inputPlaceholder, setInputPlaceholder] = useState('')
  const inputNameModalTitle = ['新建分组', '修改分组名称', '修改设备名称'];

  /* 组内应用安装和未安装弹窗状态 */
  const [appTransferVisible, setAppTransferVisible] = useState(false);

  /* 当前操作的组id或者设备id */
  const [selectedGroupIdOrCid, setSelectedGroupIdOrCid] = useState();
  
  const [disabledSdk, setDisabledSdk ] = useState(false)

  /* 输入框点击确认 */
  const handleInputNameOnOk = async () => {

    if (inputName.length > 10) {
      message.warning('请输入10个以内字符！')
      return
    }

    if (inputNameState === 0) {
      await GroupStore.groupAdd({
        groupName: inputName,
        roomId: BaseStore.RoomStore.activeRoom.id
      })
    }
    if (inputNameState === 1) {


      await GroupStore.groupRename({
        groupName: inputName,
        roomId: BaseStore.RoomStore.activeRoom.id,
        groupId: Number(selectedGroupIdOrCid),
      })
    }

    if (inputNameState === 2) {
      await DeviceOperation.RenameStore.deviceRename({
        cidName: inputName,
        cid: String(selectedGroupIdOrCid),
      })
    }

    setInputNameVisible(false);
    setInputName('')
  }

  /* 选择应用 */
  const handleAppOnChange = (value: number) => DeviceOperation.AppManagementStore.setActiveAppId(value)

  /* 移动分组弹窗状态 */
  const [moveVisible, setMoveVisible] = useState(false);

  /* 移动分组选择分组 */
  const handleMoveOnChange = (value: number) => DeviceOperation.MoveStore.setGroupId(value)

  /* 移动分组 */
  const handleMoveDevice = async () => {

    log({pageId: 'P09',eventId: 'E0901', ext: ''})

    await DeviceOperation.MoveStore.deviceMove();

    await UserStore.GroupStore.getGroupList({roomId: roomData.id});

    await DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});

    let cids = DeviceStore.DeviceBaseStore.deviceList.map(item => item.cid);

    let selectedCids: any = []

    DeviceStore.DeviceBaseStore.selectedCids.map(cid => {
      if (cids.indexOf(cid) !== -1) {
        selectedCids.push(cid)
      }
      return false
    })

    DeviceStore.DeviceBaseStore.setCids(selectedCids)

    setCheckedList(selectedCids)

    setMoveVisible(false)
  }

  /* 回收云手机 */
  const handleRecycleDevice = async (value?: any) => {
    await DeviceOperation.RecoveryStore.deviceRecycle(value);

    await UserStore.GroupStore.getGroupList({roomId: roomData.id})

    await DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});

    let cids = DeviceStore.DeviceBaseStore.deviceList.map(item => item.cid);

    let selectedCids: any = []

    DeviceStore.DeviceBaseStore.selectedCids.map(cid => {
      if (cids.indexOf(cid) !== -1) {
        selectedCids.push(cid)
      }
      return false
    })

    DeviceStore.DeviceBaseStore.setCids(selectedCids)

    setCheckedList(selectedCids)

    setMoveVisible(false)
  }

  /* 重启 */
  const handleRebootDevice = async () => {
    await DeviceOperation.RebootStore.deviceReboot();
  }

  /* 恢复出厂 */
  const handleResetDevice = async () => {
    await DeviceOperation.RestartStore.deviceReset();
  }

  /* 运行应用 */
  const handleRunApp = async () => {
    log({pageId: 'P11',eventId: 'E1102', ext: ''})
    await DeviceOperation.AppManagementStore.appRun()
    setRunOrStopVisible(false)
  }

  /* 停止应用 */
  const handleStopApp = async () => {
    log({pageId: 'P31',eventId: 'E3102', ext: ''})
    await DeviceOperation.AppManagementStore.appStop()
    setRunOrStopVisible(false)
  }

  /* 一键新机 */
  const handleVasNewDevice = async () => {
    await DeviceOperation.VasNewStore.deviceVasNew()
  }

  /* ip代理 */
  const handleVasIpProxy = async () => {
    const {open, change, close, activeKeyId} = DeviceOperation.VasIpProxyStore;
    if (activeKeyId === undefined) return
    await [() => {},open, change, close][activeKeyId]()
    setVasIpProxyVisible(false)
  }

  const handleVasIpProxyOnChange = async (value: number) => {
    const {setActiveKey} = DeviceOperation.VasIpProxyStore;
    setActiveKey(value)
  }

  /* 单选 */
  const handleDeviceOnChange = (checkedList: any) => {
    setCheckedList(checkedList)
    DeviceBaseStore.setCids(checkedList)
    setIndeterminate(!!checkedList.length && checkedList.length < plainOptions.length)
    setCheckAll(checkedList.length === plainOptions.length)
  };

  /* 全选 */
  const handleDeviceOnCheckAllChange = (checked: boolean) => {
    setCheckedList(checked ? plainOptions : [])
    DeviceBaseStore.setCids(checked ? plainOptions : [])
    setIndeterminate(false)
    setCheckAll(checked)
  };

  /* 反选 */
  const handleDeviceOnCheckAntiChange = () => {
    const cids = R.without(checkedList, plainOptions)
    setCheckedList(cids)
    DeviceBaseStore.setCids(cids)
    setIndeterminate(!!cids.length && cids.length < plainOptions.length)
    setCheckAll(R.equals(cids, plainOptions))
  };

  /* 点击工具栏 */
  const handleToolbaronChange = async (e: EventType) => {


    if (e.key === 'sync') {

      if (DeviceBaseStore.selectedCidsAmount < 2) {
        message.warning('最少选择两台设备才能使用云机同步功能！')
        return
      }
      console.log(GroupStore.isDefault);
      if (GroupStore.isDefault) {
        message.warning('请将设备移出默认分组，再进行此操作！')
        return
      }

      history.push('/Synchronization')
    }

    /* 点击全选按钮 */
    if (e.type === 'checked') {
      handleDeviceOnCheckAllChange(Boolean(e.key))
    }

    /* 点反选按钮 */
    if (e.type === 'icon') {
      handleDeviceOnCheckAntiChange()
    }

    if (e.type === 'timedTasks') {
      log({pageId: 'P26',eventId: 'E2601', ext: e.key})
      // @ts-ignore
      DeviceOperation.screencapStore.setScreencapKey(e.key)
    }

    if (e.key === 'refresh' && e.type === 'button') {
      log({pageId: 'P26',eventId: 'E2600', ext: ''})
      await DeviceOperation.screencapStore.deviceScreencap()
    }

    if (e.type === 'operations') {



      if (DeviceBaseStore.selectedCids.length === 0) {
        message.warning('请选择云手机')
        return
      }
      // 移动
      if (e.key === '0') {
        log({pageId: 'P04',eventId: 'E0405', ext: ''})
        setMoveVisible(true)
        return
      }

      // 重启
      if (e.key === '2') {
        log({pageId: 'P04',eventId: 'E0403', ext: ''})
        await handleRebootDevice()
        return
      }

      if (GroupStore.isDefault) {
        message.warning('请将设备移出默认分组，再进行此操作！')
        return
      }

      // 回收
      if (e.key === '1') {
        log({pageId: 'P04',eventId: 'E0411', ext: ''})
        showConfirm(true, 'all')
      }

      // 恢复出厂
      if (e.key === '3') {
        log({pageId: 'P04',eventId: 'E0404', ext: ''})
        await showConfirmFactory()

      }
      // 启动
      if (e.key === '4') {
        log({pageId: 'P04',eventId: 'E0406', ext: ''})
        setrunOrStop(true)
        setRunOrStopVisible(true)
      }
      // 停止
      if (e.key === '5') {
        log({pageId: 'P04',eventId: 'E0407', ext: ''})
        setrunOrStop(false)
        setRunOrStopVisible(true)
      }

      // 一键新机
      if (e.key === '6') {
        log({pageId: 'P04',eventId: 'E0410', ext: ''})
        await handleVasNewDevice();
      }
      // ip代理
      if (e.key === '7') {
        log({pageId: 'P04',eventId: 'E0409', ext: ''})
        setVasIpProxyVisible(true)
      }

    }
    // 续费
    if (e.key === 'renewal') {
      log({eventId: 'E0408', pageId: 'P04', ext: ''})
      await RenewalStore.getRenewList()
    }

    if (e.key === 'appControl') {

      log({pageId: 'P04', eventId: 'E0402', ext: ''})

      if (GroupStore.isDefault) {
        message.warning('请将设备移出默认分组，再进行此操作！')
        return
      }
      /* 获取安装和未安装列表 */
      await DeviceOperation.AppManagementStore.getInstallUninstallList();
      setAppTransferVisible(true)

    }

    // 上传文件
    if (e.key === 'upload') {
      log({eventId: 'E0401', pageId: 'P04', ext: '',})
      BaseStore.UploadStore.changeModalShow(true)
    }

  }

  const showConfirm = (type: boolean, value: string) => {
    const { confirm } = AModal;
    confirm({
      title: '',
      content: '此操作将清除您的个人数据并将所选云手机移动至默认分组，是否继续',
      onOk:async () => {
        type ? await handleRecycleDevice() : await handleRecycleDevice(value)
      },
      onCancel() {

      },
    })
  }

  const showConfirmFactory = () => {
    const { confirm } = AModal;
    confirm({
      title: '',
      content: '此操作将清除您的个人数据，是否继续',
      onOk:async () => {
       await handleResetDevice()
      },
      onCancel() {

      },
    })
  }

  /* 点击分组 */
  const handleGoruponChange = async (e: any) => {

    /* 展开/折叠 */
    if (e.type === 'collapse') {

      if (Number(e.key) === GroupStore.activeGroupId) return

      setActiveKey(e.key)
      DeviceBaseStore.setCids([])
      setIndeterminate(true)
      setCheckAll(false)
      await handleGroupChange(e.key, false)
    }

    if (e.type === 'edit') {
      log({ pageId: 'P28',eventId: 'E2811', ext: ''})
      setInputNameState(2);
      setInputNameVisible(true);
      setInputPlaceholder(R.find(R.propEq('cid', e.value))(DeviceBaseStore.deviceList).deviceName)
      setSelectedGroupIdOrCid(e.value);

    }

    if (e.type === 'checkboxAll') {
      console.log(e);
      if (e.value === GroupStore.activeGroupId) {
        handleDeviceOnCheckAllChange(e.key)
      } else {
        await handleGroupChange(e.value, e.key)
      }
    }

    if (e.type === 'checkbox') {
      /* 合集 or 差集 */
      let cids = e.key ? R.union(checkedList, [e.value]) : R.difference(checkedList, [e.value])
      handleDeviceOnChange(cids)
    }

    if (e.type === 'button') {
      log({ pageId: 'P28',eventId: 'E2800', ext: ''})
      setInputNameState(0);
      setInputName('')
      setInputNameVisible(true)
      setInputPlaceholder('')
    }

    if (e.type === 'icon') {
      if (e.key === 'edit') {
        log({ pageId: 'P28',eventId: 'E2803', ext: ''})
        setInputNameState(1);
        setInputNameVisible(true);
        setInputName('')
        setSelectedGroupIdOrCid(e.value)
        setInputPlaceholder(R.find(R.propEq('id', e.value))(GroupStore.groupList).groupName)
      }

      if (e.key === 'delete') {
        log({ pageId: 'P28',eventId: 'E2808', ext: ''})
        setSelectedGroupIdOrCid(e.value);
        AModal.confirm({
          title: '您确认删除分组吗?',
          okText: '确认',
          cancelText: '取消',
          onOk: () => GroupStore.groupDelete({
            groupId: e.value,
            roomId: BaseStore.RoomStore.activeRoom.id
          }),
        });
      }

    }

  }

  /* 分组展开时 */
  const handleGroupChange = async (key: string | string[], type: boolean) => {
    if (key) {
      GroupStore.setGroupId(Number(key))
      /* 获取设备数据 */
      await DeviceBaseStore.getDeviceList({groupId: key});
      const cids: any = DeviceBaseStore.deviceList.map(item => item.cid)
        setPlainOptions(cids)

      if (type) {
        setCheckedList(type ? cids : [])
        DeviceBaseStore.setCids(type ? cids : [])
        setIndeterminate(false)
        setCheckAll(type)
      }

      /* 获取运行停止应用列表 */
      await DeviceOperation.AppManagementStore.getGroupAppRunStopList();

      /* 获取数量信息 */
      await DeviceBaseStore.getDeviceInfo()

    }
  }

  /* 点击设备时 */
  const handleDeviceChange = async (e: any) => {

    if (e.type === 'checkbox') {
      let cids = e.key ? R.union(checkedList, [e.value]) : R.difference(checkedList, [e.value])
      handleDeviceOnChange(cids)
    }

    if (e.type === 'screen') {
      DeviceModalStore.coludStatus = 'start'
      await initCloud(e.value)
    }

    if (e.type === 'icon' && e.key === 'edit') {
      log({ pageId: 'P28',eventId: 'E2811', ext: ''})
      setInputNameState(2);
      setInputNameVisible(true);
      setSelectedGroupIdOrCid(e.value);
      setInputPlaceholder(R.find(R.propEq('cid', e.value))(DeviceBaseStore.deviceList).deviceName)
    }


    if (e.type === 'button') {

      if (e.key === '1') {
        log({ pageId: 'P04',eventId: 'E0403', ext: e.value})

        await DeviceOperation.RebootStore.deviceReboot(e.value)
      }

      if (GroupStore.isDefault) {
        message.warning('请将设备移出默认分组，再进行此操作！')
        return
      }

      if (e.key === '2') {
        log({ pageId: 'P04',eventId: 'E0411', ext: e.value})
        showConfirm(false, e.value)
      }

      if (e.key === '3') {
        log({ pageId: 'P04',eventId: 'E0407', ext: e.value})
        await DeviceOperation.AppManagementStore.appStop(e.value)
      }

      if (e.key === '4') {
        log({ pageId: 'P04',eventId: 'E0412', ext: e.value})
        await DeviceOperation.RepairStore.deviceRepair(e.value)
      }

    }

  }

  /* 组内应用管理弹窗应用列表改变 */
  const handleAppControlChange = (e: any) => {
    setInUnList(e)
  }

  /* 组内应用管理弹窗点击确定 */
  const handleAppOk = async () => {
    log({ pageId: 'P10',eventId: 'E1002', ext: ''})
    setAppTransferVisible(false)
    await appInstallUninstall()
  }


  /* 点击续费确定*/
  const goRenewal = () => {
    // 续费点击确定 事件上报
    log({
      eventId: 'E1201',
      pageId: 'P12',
      ext: '',
    })
    if(!RenewalStore.productIds.length){
      message.warning('请选择要续费的云手机')
      return;
    }
    RenewalStore.toggoleRenewalModel()
    // 本地存储续费云机，防止续费页面刷新数据丢失
    window.sessionStorage.setItem('RenewalProductIds', JSON.stringify(RenewalStore.productIds))
    window.sessionStorage.setItem('RenewalProductId', JSON.stringify(RenewalStore.productId))
    history.push('/Home/Renewal')
  }

  useEffectOnce(() => {

    (async () => {
      log({pageId: 'P04', eventId: 'E0400', ext: ''})
      if (roomData) {
        await GroupStore.getGroupList({roomId: roomData.id});
        await DeviceBaseStore.getDeviceInfo(roomData.id)
      }
      //播流大小、横竖
      const sizeType = window.localStorage.getItem('sizeTypeSingle');
      const rotateType = window.localStorage.getItem('rotateTypeSingle');
      sizeType ? DeviceModalStore.setSizeType(sizeType) : DeviceModalStore.setSizeType('small');
      rotateType ? DeviceModalStore.setRotateType(rotateType) : DeviceModalStore.setRotateType('vertical');
    })();

    (async () => {
      // 获取活动
      isUsedFreeDevice()
      // 获取公告
      getnNoticeInfo()
    })()
  })

  useMount(() => {
    GroupStore.setGroupId(-1);
    DeviceBaseStore.setDeviceList([]);
    DeviceBaseStore.setCids([])
  })

  // 领取活动
  const getActive = async () => {
    onChangeShowActive(false)

    let params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
      channel: window.localStorage.getItem('channel') || ''
    }
    const [error, result] = await getActiveApi(params)
    if (error) {
      log({eventId: 'E2402', pageId: 'P24', ext: ''})

      if(result.code === 50010 || result.code === 50011) {
        message.error('本次注册存在违规行为，无法领取免费赠送的设备。')
      }
      if (result.code === 50012) {
        AModal.warning({
          title: '提示',
          content: (<div>
            已达今日领取上限，<br />无法自动领取免费赠送的设备<br />请加入爱云兔QQ号:133344065<br />联系工作人员申请。
            </div>
            )
        });
      }
      return;
    }
    log({eventId: 'E2401', pageId: 'P24', ext: ''})

    AModal.confirm({
      title: '提示',
      content: '领取成功，是否跳转到订单详情页面？',
      onOk() {
        props.UserStore.OrderStore.setSelected(1);
        history.push('/Home/Order');
      },
      onCancel() {
      },
    });
  }

  const initCloud = async (cid: string) => {
    DeviceModalStore.mask = 'show'
    await DeviceModalStore.initCloud(cid);
    const {accessKeyId, masterId, slaveIds, packageName, cap, token} = DeviceModalStore;

    DeviceModalStore.cloudPlay = new (window as any).Cloudplay({
      accessKeyId,
      masterId,
      slaveIds,
      packageName,
      cap,
      token,
      userInfo: {
        userId: decodeInfo.uid,
        userToken: decodeInfo.token
      },
      onSceneChanged: onSceneChanged
    });
  }

  //播流回调
  const onSceneChanged = (start: any, stop: any) => {
    console.log(start, stop)
    if (start === 'stop') {
      setDisabledSdk(true)
    }
    if (start === 'start') {
      setDisabledSdk(false)
    }
    if (!start) return;
    DeviceModalStore.coludStatus = 'fail';
  }

  const backspace = (id: string) => {
    DeviceModalStore.cloudPlay.backspace(id)
  }

  const home = (id: string) => {
    DeviceModalStore.cloudPlay.home(id)
  }

  const menu = (id: string) => {
    DeviceModalStore.cloudPlay.menu(id)
  }

  const volumeUp = (id: string) => {
    DeviceModalStore.cloudPlay.volumeUp(id);
  }

  const volumeDown = (id: string) => {
    DeviceModalStore.cloudPlay.volumeDown(id);
  }

  const closeMask = () => {
    DeviceModalStore.mask = 'hidden';
    if (DeviceModalStore.cloudPlay && DeviceModalStore.cloudPlay.quit ) {
      try {
        DeviceModalStore.cloudPlay.quit()
      } catch (e) {

      }
    }
  }

  const rotateTypeChange = () => {
    DeviceModalStore.rotateType === 'vertical' ? DeviceModalStore.setRotateType('across') : DeviceModalStore.setRotateType('vertical')
  }

  const sizeTypeChange = async (type: string) => {
    
    if (disabledSdk) {
      message.warning({
        content: '设备正在重连，请稍后操作！',
      })
      return false
    }
    
    if (type === DeviceModalStore.sizeType) {
      return false
    }

    DeviceModalStore.cloudPlay.quit();
    DeviceModalStore.coludStatus = 'start';
    DeviceModalStore.setSizeType(type)
    await initCloud(DeviceModalStore.masterId)
  }

  const setListChange = () => {
    DeviceModalStore.setList = DeviceModalStore.setList === 'hidden' ? 'show' : 'hidden';
  }
  
  // 根据cid查找名字
  const getDeviceName = (cid: string) => {
    let data = R.find(R.propEq('cid', cid))(DeviceBaseStore.deviceList)
    return data? data.deviceName || cid : cid
  }

  return (
    <>
      <Toolbar
        selectOptions={{checkedList, indeterminate, checkAll}}
        screencapOptions={{name: DeviceOperation.screencapStore.name}}
        onChange={handleToolbaronChange}/>
      <Row style={{flexDirection: 'row',justifyContent: 'flex-start', flexWrap: 'inherit', width: '100%'}} type='flex' gutter={[16, 16]}>
        <Group
          activeGroupId={GroupStore.activeGroupId}
          activeKey={activeKey}
          selectOptions={{checkedList, indeterminate, checkAll}}
          onChange={handleGoruponChange}
          deviceDataSource={DeviceBaseStore.deviceList}
          groupDataSource={GroupStore.groupList}/>
        <Col style={{flex: 'auto', marginTop: 16}}>
          <Device.DeviceList
            onChange={handleDeviceChange}
            selectOptions={{checkedList, indeterminate, checkAll}}
            dataSource={DeviceBaseStore.deviceList}/>
        </Col>
      </Row>
      <Device.DeviceInfo selected={DeviceBaseStore.selectedCidsAmount}  {...DeviceBaseStore.deviceInfo} />
      <Resident.Customer/>
      <Modal.Select
        title='移动云手机'
        visible={moveVisible}
        onCancel={() => {
          log({pageId: 'P09',eventId: 'E0902', ext: ''})
          setMoveVisible(false)}}
        onOk={handleMoveDevice}
        onChange={handleMoveOnChange}
        dataSource={DeviceOperation.MoveStore.groupListFilter()}>
      </Modal.Select>
      <Modal.Select
        title={runOrStop ? '运行' : '停止'}
        visible={runOrStopVisible}
        onCancel={() => {
          if (runOrStop) {
            log({ pageId: 'P11',eventId: 'E1003', ext: ''})
          } else {
            log({ pageId: 'P31',eventId: 'E3103', ext: ''})
          }
          setRunOrStopVisible(false)}}
        onOk={runOrStop ? handleRunApp : handleStopApp}
        onChange={handleAppOnChange}
        dataSource={DeviceOperation.AppManagementStore.groupAppRunStopList.map((r: any) => ({
          id: r.gameId,
          name: r.gameName
        }))}>
      </Modal.Select>
      <Modal.Renewal
        getDeviceName={getDeviceName}
        visible={RenewalStore.renewalModel}
        productList={RenewalStore.productList}
        deviceList={RenewalStore.getDeviceList}
        changeActive={RenewalStore.changeProduct}
        productIds={RenewalStore.productIds}
        onChange={RenewalStore.changeproductIds}
        onCancel={() => RenewalStore.toggoleRenewalModel()}
        onOk={goRenewal}
        onAllSelect={RenewalStore.toggleAllCheck}
      >
      </Modal.Renewal>
      <Modal.Select
        title='ip代理'
        visible={vasIpProxyVisible}
        onCancel={() => setVasIpProxyVisible(false)}
        onOk={handleVasIpProxy}
        onChange={handleVasIpProxyOnChange}
        dataSource={[{id: 1, name: '开启'}, {id: 2, name: '切换'}, {id: 3, name: '关闭'}]}>
      </Modal.Select>
      <Modal.Input
        title={inputNameModalTitle[inputNameState]}
        visible={inputNameVisible}
        placeholder={inputPlaceholder}
        onCancel={() => setInputNameVisible(false)}
        onOk={handleInputNameOnOk}
        value={inputName}
        onChange={(e) => {
          return setInputName(e.target.value);
        }}>
      </Modal.Input>
      <Modal.Transfer
        title='组内应用管理'
        dataSource={[groupAppInstallList, groupAppUninstall]}
        visible={appTransferVisible}
        onCancel={() => {
          log({ pageId: 'P10',eventId: 'E1003', ext: ''})
          setAppTransferVisible(false)}}
        onOk={handleAppOk}
        onChange={handleAppControlChange}>
      </Modal.Transfer>

      <PhoneModal
        mask={DeviceModalStore.mask}
        actions={{
          backspace: backspace,
          home: home,
          menu: menu,
          volumeDown: volumeDown,
          volumeUp: volumeUp
        }}
        masterId={DeviceModalStore.masterId}
        closeMask={closeMask}
        coludStatus={DeviceModalStore.coludStatus}

        setList={DeviceModalStore.setList}
        setListChange={setListChange}

        sizeType={DeviceModalStore.sizeType}
        sizeTypeChange={sizeTypeChange}

        rotateType={DeviceModalStore.rotateType}
        rotateTypeChange={rotateTypeChange}
      >
      </PhoneModal>

      {/*文件管理*/}
      {BaseStore.UploadStore.showModal?<FileOpear BaseStore={BaseStore}></FileOpear>:null}

      {/* 停服公告    当活动弹框不展示且停服要显示的时*/}
      {!getShowActive && UIStore.CloseDown.getShowCloseDown && !UIStore.CloseDown.alreadyShowCloseDown && <CloseDown msg={UIStore.CloseDown.msg} changeCloseShow={UIStore.CloseDown.setShowCloseDown}/>}

      {/*活动弹框*/}
      {!alreadyShowActive && <Active showActive={getShowActive} onChangeShowActive={onChangeShowActive} getActive={getActive}/>}
    </>
  )

}))

export default Home;
